import { I18n } from '@calendly/i18n';
import { LabelText } from '@calendly/ui/components/typography';
/**
 * Sticky under utility hairline — Figma: spacing1x (16) above label,
 * spacing0_75x (12) below toward the first meeting card.
 */
const countCss = "csnoux7";
export const MeetingsPhoneDisplayedCount = ({
  count = 0
}) => <div className={countCss} data-testid="meetings-phone-displayed-count">
    <LabelText color="muted" size="small" data-testid="meetings-displayed-count">
      {I18n.t('publisher.meetings.preset_tabs.displaying_meetings', {
      count
    })}
    </LabelText>
  </div>;

require("./meetings_phone_displayed_count.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meetings_phone_displayed_count.js");